import { validateSomething } from "../../Form/Validations";
import RestAPI from "@aws-amplify/api-rest";
export class JohnDeere {

    static sectoresArray = null;
    static equiposArray = null;
    static callbackJohnDeere = "https://localhost:3000/callback/jhondeere";
    static client_JohnDeere= "johndeere-U6spHKcFP5TFrYBrPOvxTPtGYnaXA0wxF8pVrhek";
    static jd_childs =[];
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        return {
            visible: true,
            activeStep: 0,
            data: data.data,
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const body = {
                    ...values,
                    organization_name:props?.dialogState?.data?.organizations?.find(o => o.id===values.organization).name,
                    tokens: props?.dialogState?.data?.tokens,
                    tipo: "JOHNDEERE",
                    locale: i18n.language
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("sass.conectar"),
                    inputs: [
                        {
                            label: t("marketplace.org"),
                            campo: "organization",
                            validation: JohnDeere.validateOrg,
                            component: "select",
                            optionsName: "organizations",
                            optionLabel: "name",
                            optionKey: "id",
                            onChange: async (value, props, options) => {
                                props.setForceLoading(true);
                                const org = options.find(l => l.id===value);
                                const connectionLink = org.links?.find(l => l.rel==="connections");
                                if(connectionLink){
                                    props.setFieldValue("organization", value);
                                    props.setFieldValue("organization_validation", false);
                                    props.setForceLoading(false);
                                }else {
                                    props.setFieldValue("organization", value);
                                    props.setFieldValue("organization_validation", true);
                                    props.setForceLoading(false);
                                }
                            }
                        },
                        {
                            label: t("marketplace.validateOrg"),
                            component: "buttonValidation",
                            triggeredBy: "organization",
                            validation_error:"org_error",
                            validationField: "organization_validation",
                            notInReview:true,
                            validation_function: async (props, values) => {
                                const connectionOrg = async (url, token) => {
                                    return new Promise((resolve, reject) => {
                                        try {
                                            const width = 500;
                                            const height = 400;
                                            const left = window.screenX + (window.outerWidth - width) / 2;
                                            const top = window.screenY + (window.outerHeight - height) / 2.5;
                                            const popup = window.open(url, "Sign In", `width=${width},height=${height},left=${left},top=${top}`);
                                            const interval = setInterval(async () => {
                                                if(popup.closed){
                                                    const endpoint = `/external/${props.farmId}/john-deere-organizations`;
                                                    const restBody = {
                                                        "token":token
                                                    };
                                                    const response = await RestAPI.post("apiAdminDropControl", endpoint, { body:restBody });
                                                    interval && clearInterval(interval);
                                                    resolve(response?.organizations);
                                                }
                                                try {
                                                    const currentUrl = popup?.location?.href;
                                                    if (!currentUrl) {
                                                        return;
                                                    }
                                                    if(currentUrl===JohnDeere.callbackJohnDeere){
                                                        interval && clearInterval(interval);
                                                        popup.close();
                                                        const endpoint = `/external/${props.farmId}/john-deere-organizations`;
                                                        const restBody = {
                                                            "token":token
                                                        };
                                                        const response = await RestAPI.post("apiAdminDropControl", endpoint, { body:restBody });
                                                        resolve(response?.organizations);
                                                    }
                                                } catch (e) {
                                                    if (!(e instanceof DOMException)) {
                                                        reject(false);
                                                    }
                                                }
                                            }, 500);
                                        } catch (e) {
                                            console.error(e);
                                            reject(false);
                                        }
                                    });
                                };
                                props.setForceLoading(true);
                                const org = props?.dialogState?.data?.organizations?.find(l => l.id===values.organization);
                                const connectionLink = org.links?.find(l => l.rel==="connections");
                                const connectionUrl = `${connectionLink.uri}?redirect_uri=${JohnDeere.callbackJohnDeere}`;
                                const datos = await connectionOrg(encodeURI(connectionUrl), props?.dialogState?.data?.tokens?.access_token);
                                console.log(datos);
                                if(datos){
                                    const _org = datos?.find(l => l.id===values.organization);
                                    const _connectionLink = _org.links?.find(l => l.rel==="connections");
                                    console.log(_org);
                                    console.log(_connectionLink);
                                    if(_connectionLink){
                                        props.setFieldError("org_error",t("marketplace.validateOrgError"));
                                        props.setForceLoading(false);
                                    }else{
                                        props.setFieldValue("organization_validation", true);
                                        props.setForceLoading(false);
                                    }
                                }else{
                                    props.setFieldError("org_error",t("marketplace.validateOrgError"));
                                    props.setForceLoading(false);
                                }
                            }
                        },
                        {
                            label: t("farms.etiqueta.equipos").toLowerCase(),
                            campo: "equipos",
                            component: "multiSelect",
                            options:JohnDeere.equiposArray,
                            optionsName: "equipos",
                            optionLabel: "nombre",
                            optionKey: "equipo_id",
                            triggeredBy: "organization_validation",
                            notInReview:true,
                        },
                        {
                            label: t("farms.etiqueta.sectores").toLowerCase(),
                            campo: "sectores",
                            component: "multiSelect",
                            options:JohnDeere.sectoresArray,
                            optionsName: "sectores",
                            errorLbl:t("validation.required"),
                            optionLabel: "nombre",
                            optionKey: "sector_id",
                            triggeredBy: "organization_validation",
                            notInReview:true,
                        },
                        {
                            label: t("farms.etiqueta.equipos").toLowerCase(),
                            campo: "equipos",
                            component: "infoList",
                            options:JohnDeere.equiposArray,
                            optionsName: "equipos",
                            optionLabel: "nombre",
                            optionKey: "equipo_id",
                        },
                        {
                            label: t("farms.etiqueta.sectores").toLowerCase(),
                            campo: "sectores",
                            component: "infoList",
                            optionsName: "sectores",
                            options:JohnDeere.sectoresArray,
                            optionLabel: "nombre",
                            optionKey: "sector_id",
                        },
                    ],
                    validateFunction: JohnDeere.validateJD,
                },
            ],
        };
    }
    static async validateOrg(value) {
        if(JohnDeere.jd_childs.find(o => o.orgId === value)){
            return "external.org_connected";
        }
    }
    static async validateJD(values, props) {
        const errors= {};
        if (values) {
            const errOrg = validateSomething(values.organization);
            if (errOrg !== undefined) errors.organization = errOrg;
            if(values.organization && values.organization_validation===false){
                errors.org_error ="marketplace.validateOrgError";
            }
            if((!values?.equipos && !values?.sectores)){
                errors.sectores ="validation.errJonhDeere";
            }
            else if(values?.equipos){
                if(values?.equipos?.length === 0 && (values?.sectores?.length === 0 || !values?.sectores)){
                    errors.sectores ="validation.errJonhDeere";
                }
            }
            else if(values?.sectores){
                if((values?.equipos?.length === 0 || !values?.equipos) && values?.sectores?.length === 0){
                    errors.sectores ="validation.errJonhDeere";
                }
            }
            return errors;
        }
    }
    static async validateEquiposSector(values, props) {
        const errors= {};
        if (values) {
            if((!values?.equipos && !values?.sectores)){
                errors.sectores ="validation.errJonhDeere";
            }
            else if(values?.equipos){
                if(values?.equipos?.length === 0 && (values?.sectores?.length === 0 || !values?.sectores)){
                    errors.sectores ="validation.errJonhDeere";
                }
            }
            else if(values?.sectores){
                if((values?.equipos?.length === 0 || !values?.equipos) && values?.sectores?.length === 0){
                    errors.sectores ="validation.errJonhDeere";
                }
            }
            return errors;
        }
    }
    /**
   * @returns {import("../types").DialogState}
  */
    static updateJD(t, data, i18n) {
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            skipCostStep: true,
            skipReviewStep: true,
            hideStepper: true,
            confirmButtonLabel: t("general.confirm"),
            dataConnected:data.dataConnected,
            resolveBody: (values, props) => {
                const body = {
                    ...values,
                    organization:props?.dialogState?.dataConnected?.id,
                    organization_name:props?.dialogState?.dataConnected?.name,
                    tokens: props?.dialogState?.dataConnected?.tokens,
                    tipo: "JOHNDEERE",
                    locale: i18n.language
                };
                return {
                    url: `/external/${props.farmId}/john-deere-update`,
                    body: body
                };
            },
            steps: [
                {
                    label: t("forms.update"),
                    inputs: [
                        {
                            label: t("farms.etiqueta.equipos").toLowerCase(),
                            campo: "equipos",
                            component: "multiSelect",
                            options:JohnDeere.equiposArray,
                            optionsName: "equipos",
                            optionLabel: "nombre",
                            optionKey: "equipo_id",
                            notInReview:true,
                            valuesPrev:data?.connection_data?.assets?.equipo
                        },
                        {
                            label: t("farms.etiqueta.sectores").toLowerCase(),
                            campo: "sectores",
                            component: "multiSelect",
                            options:JohnDeere.sectoresArray,
                            optionsName: "sectores",
                            errorLbl:t("validation.required"),
                            optionLabel: "nombre",
                            optionKey: "sector_id",
                            notInReview:true,
                            valuesPrev:data?.connection_data?.assets?.sector
                        }
                    ],
                    validateFunction: JohnDeere.validateEquiposSector
                },
            ],
        };
    }
}
